import { Trans } from "@lingui/react/macro";
import { createFileRoute, Link } from "@tanstack/react-router";
import { z } from "zod";

import { AnalysisPage, analysisSearchSchema } from "@/features/analysis";

const matchIdSchema = z.coerce.number().int().positive();

// Ссылка «назад к матчам» — часть раскладки страницы, а не экрана разбора: `Link` нужен
// контекст роутера, а `AnalysisPage` рендерится и в тестах без него.
// Открытая секция разбора — в search params; меняется без новой записи в истории браузера
// и без прокрутки наверх: к секции прокручивает сам экран.
const MatchPage = () => {
  const { matchId } = Route.useParams();
  const { section } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <>
      <div className="mx-auto w-full max-w-[1200px] px-6 pt-4">
        <Link to="/" className="text-sm text-muted no-underline hover:text-foreground">
          <span aria-hidden="true">← </span>
          <Trans>Back to matches</Trans>
        </Link>
      </div>
      <AnalysisPage
        matchId={matchId}
        section={section}
        onSectionChange={(next) =>
          void navigate({ search: { section: next }, replace: true, resetScroll: false })
        }
      />
    </>
  );
};

export const Route = createFileRoute("/matches/$matchId")({
  params: {
    parse: ({ matchId }) => ({ matchId: matchIdSchema.parse(matchId) }),
    stringify: ({ matchId }) => ({ matchId: String(matchId) }),
  },
  validateSearch: analysisSearchSchema,
  component: MatchPage,
});
